export default __webpack_public_path__ + "static/media/maximum_bet_500$.ed7c8f7d.mp3";